import moment from "moment";
import { normalizeDashboardModule, groupTrackingResults } from '../../utils/dashboardTracking';

export { normalizeDashboardModule, getTrxDetail, normalizeMostActiveModuleData } from '../../utils/dashboardTracking';

export const formatDateToObjectFromAndTo = (date, dateTo) => {
    if (!date && !dateTo) return null;

    if (dateTo && !date) {
        return {
            to: moment(dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
        };
    }
    if (date && !dateTo) {
        return {
            from: moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
        };
    }

    return {
        from: moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
        to: moment(dateTo).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'),
    };
};

export const normalizeValueForColor = (value, data) => {
    const min = Math.min(...data.map(item => item.view_count));
    const max = Math.max(...data.map(item => item.view_count));
    if (max === min) return 40;
    return 70 - ((value - min) * (70 - 30)) / (max - min);
};

export const showData = (showAll, data) => {
    if (showAll) return data;
    return data.slice(0, 10);
};

export const aggregateByDate = (results = [], fromDate = null, toDate = null) => {
    const byDate = {};
    results.forEach(item => {
        const date = moment(item.datetime).format('YYYY-MM-DD');
        const normalizedModule = normalizeDashboardModule(item.module);
        if (!byDate[date]) {
            byDate[date] = { date, modules: new Set(), total: 0 };
        }
        byDate[date].modules.add(normalizedModule);
        byDate[date].total += 1;
    });

    const dataKeys = Object.keys(byDate).sort();
    const start = fromDate
        ? moment(fromDate).format('YYYY-MM-DD')
        : dataKeys[0];
    const end = toDate
        ? moment(toDate).format('YYYY-MM-DD')
        : dataKeys[dataKeys.length - 1];

    if (!start || !end) return [];

    const filledDates = [];
    let current = moment(start);
    const endMoment = moment(end);

    while (current.isSameOrBefore(endMoment, 'day')) {
        const dateStr = current.format('YYYY-MM-DD');
        const entry = byDate[dateStr];
        filledDates.push({
            date: dateStr,
            distinctDashboards: entry ? entry.modules.size : 0,
            totalLoads: entry ? entry.total : 0,
        });
        current.add(1, 'day');
    }

    return filledDates;
};

// Single-user view: group by date + normalized module only
export const groupByDateAndModule = (results = []) =>
    groupTrackingResults(results, false);
